import React from 'react';
import { cn } from '@/lib/utils';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';
import { LucideIcon } from 'lucide-react';

interface LoadingStateProps {
  message?: string;
  /** Optional static brand icon instead of the default spinner */
  icon?: LucideIcon;
  className?: string;
  /** Render as full-page centered (default) or inline */
  inline?: boolean;
}

/**
 * Consistent loading state with spinner and optional message.
 */
export function LoadingState({
  message = 'Loading...',
  icon: Icon,
  className,
  inline = false,
}: LoadingStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-4 text-center px-5',
        inline ? 'py-6' : 'py-16',
        className
      )}
      role="status"
      aria-label={message}
    >
      {Icon ? (
        <Icon aria-hidden className="h-8 w-8 text-primary" />
      ) : (
        <LoadingSpinner size="lg" label={message} />
      )}
      <p className="text-sm text-muted-foreground">{message}</p>
      <div aria-hidden className="gd-loading h-1 w-24 rounded-full" />
    </div>
  );
}
